<template>
  <div v-show="false">{{invitationLink}}</div>
</template>
<script>
import { queryConference } from '@/api/coc'
import { getFullFormatText, copyToClipboard } from '@/utils/copyInvitationLink'
export default {
  name: 'CopyInvitationLinkMixin',
  data() {
    return {
      invitationLink: '',
      conferenceIdCache: ''
    }
  },
  methods: {
    handleIsRepeatConferenceId(conferenceId){
      if (this.conferenceIdCache === conferenceId) return true
      this.conferenceIdCache = conferenceId
    },
    async handleSetInvitationLink(conferenceId){
      if (this.handleIsRepeatConferenceId(conferenceId)) return

      const data = await queryConference(conferenceId)
      const { theme, tags, beginTime, endTime } = data
      this.copyText = await getFullFormatText({ theme, tags, beginTime, endTime, conferenceId })
    },
    async handleSetInvitationLinkOfData({ theme, tags, beginTime, endTime, conferenceId }){
      if (this.handleIsRepeatConferenceId(conferenceId)) return

      this.copyText = await getFullFormatText({ theme, tags, beginTime, endTime, conferenceId })
    },
    handleCopyInvitationLink() {
      copyToClipboard(this.copyText)
    },
  }
}
</script>
